import { Button, Grid, Typography } from '@mui/material';

import { Button as StyledButton } from '../../common';
import StyledModal from '../StyledModal';
import { admin } from '../../../utils/api';

export default function DeletePlotModal(props) {
  const handleClose = () => {
    props.setOpen(false);
  };
  const handleDeleteUser = () => {
    admin
      .deleteUser(props.currentID)
      .then((result) => {
        props.update();
        handleClose();
      })
      .catch((err) => {});
  };

  return (
    <StyledModal open={props.open} handleClose={handleClose}>
      <Grid container justifyContent="center">
        <Typography
          sx={{ fontSize: 36, fontWeight: 500, mb: 1, mt: 1, px: 4, py: 2 }}
        >
          Czy na pewno chcesz usunąć użytkownika?
        </Typography>
      </Grid>
      <Grid container justifyContent="center">
        <StyledButton
          red
          type="submit"
          variant="outlined"
          onClick={props.handleBack}
          sx={{ mr: 5 }}
        >
          ANULUJ
        </StyledButton>
        <Button type="submit" variant="outlined" onClick={handleDeleteUser}>
          TAK, USUŃ
        </Button>
      </Grid>
    </StyledModal>
  );
}
